var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.960938H513V342.928H0V0.960938Z",
    fill: "#0021AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.960938H513V342.928",
    fill: "#1C8A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7516 273.492L83.4627 285.415L96.2877 282.409L90.5766 294.333L100.897 302.448L88.0717 305.354V318.58L77.7516 310.264L67.5316 318.58V305.354L54.7066 302.448L65.0268 294.333L59.2154 282.409L72.1406 285.415L77.7516 273.492ZM40.5791 174.399L46.2902 186.322L59.1152 183.316L53.4041 195.139L63.7242 203.355L50.799 206.261L50.8992 219.487L40.5791 211.171L30.259 219.487L30.3592 206.261L17.434 203.355L27.8543 195.139L22.043 183.316L34.868 186.322L40.5791 174.399ZM77.7516 93.3408L83.4627 105.164L96.2877 102.258L90.5766 114.081L100.897 122.297L88.0717 125.203V138.329L77.7516 130.112L67.5316 138.329V125.203L54.7066 122.297L65.0268 114.081L59.2154 102.258L72.1406 105.164L77.7516 93.3408ZM123.942 156.364L129.653 168.287L142.478 165.281L136.767 177.204L147.087 185.32L134.262 188.226V201.452L123.942 193.236L113.722 201.452V188.226L100.897 185.32L111.217 177.204L105.506 165.281L118.331 168.287L123.942 156.364ZM90.9773 210.469L95.3859 224.196H109.914L98.1914 232.713L102.7 246.439L90.9773 238.023L79.2545 246.439L83.7633 232.713L72.0404 224.196H86.4686L90.9773 210.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.622 246.64C308.847 246.64 342.267 213.22 342.267 171.994C342.267 130.769 308.847 97.3486 267.622 97.3486C226.396 97.3486 192.976 130.769 192.976 171.994C192.976 213.22 226.396 246.64 267.622 246.64Z",
    fill: "#FFC639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.622 221.691H292.47C292.47 221.691 303.291 202.654 292.47 184.419L317.319 159.57L304.894 134.722H292.47C292.47 134.722 286.258 153.358 261.41 153.358C236.561 153.358 230.349 134.722 230.349 134.722H217.925L230.349 159.57L217.925 184.419L230.349 196.843C230.349 196.843 242.773 171.994 267.622 184.419C267.622 184.419 278.142 199.949 267.622 221.691Z",
    fill: "#1C8A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.307 93.3412C465.908 90.4355 465.107 75.7068 465.107 72.6008C465.107 51.2592 451.18 33.1238 431.842 26.8115C437.753 38.835 441.06 52.2611 441.06 66.5891C441.06 71.3984 440.659 76.1076 439.958 80.7166C437.052 76.0074 433.345 71.7992 428.736 68.092C411.602 54.4654 388.056 54.0647 370.723 65.5871C384.149 68.4928 397.074 74.5045 408.496 83.6223C417.514 90.7361 424.728 100.455 430.239 109.773C430.239 109.773 412.404 120.695 399.178 124.903C385.952 129.111 356.796 132.818 356.796 132.818C428.936 144.842 489.053 96.7479 489.053 96.7479C482.541 83.3217 473.222 92.74 465.307 93.3412Z",
    fill: "#FFC639"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 0.960938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCx);
export default __webpack_public_path__ + "static/media/CX.c72f146499c4af56fa1b81fc6f714a75.svg";
export { ForwardRef as ReactComponent };